/**
 * @author yan st
 * @date 2022-08-30 13:51
 * @Description:
 */

export const adminRouter = [
    {
        path: '',
        redirect: 'index'
    },
    {
        path: 'index',
        meta: {
            title: '首页',
            needLogin: true // 是否需要登录才能访问
        },
        component: () => import('../views/admin/pages/index'),
    },
    {
        path: 'orgList',
        meta: {
            title: '机构管理',
            needLogin: true // 是否需要登录才能访问
        },
        component: () => import('../views/admin/pages/orgList'),
    },
    {
        path: 'notice',
        meta: {
            title: '通知公告',
            needLogin: true // 是否需要登录才能访问
        },
        component: () => import('../views/admin/pages/detail/noticeList'),
    },
    {
        path: 'detail',
        meta: {
            title: '详情',
            needLogin: true // 是否需要登录才能访问
        },
        component: () => import('../views/admin/pages/detail/detail'),
    },
    {
        path: 'orgList',
        meta: {
            title: '机构管理',
            needLogin: true // 是否需要登录才能访问
        },
        component: () => import('../views/admin/pages/orgList'),
    },
    {
        path: 'orgDetail',
        meta: {
            title: '机构信息',
            needLogin: true // 是否需要登录才能访问
        },
        component: () => import('../views/admin/pages/orgDetail/orgDetail'),
    },
    {
        path: 'closeshop',
        meta: {
            title: '申请闭店',
            needLogin: true // 是否需要登录才能访问
        },
        component: () => import('../views/admin/pages/orgDetail/closeshop'),
    },
    {
        path: 'moneySupervision',
        meta: {
            title: '机构信息',
            needLogin: true // 是否需要登录才能访问
        },
        component: () => import('../views/admin/pages/orgDetail/moneySupervision'),
    },
    {
        path: 'orgOperation',
        meta: {
            title: '机构信息',
            needLogin: true // 是否需要登录才能访问
        },
        component: () => import('../views/admin/pages/orgDetail/orgOperation'),
    },
    {
        path: 'supervision',
        meta: {
            title: '机构信息',
            needLogin: true // 是否需要登录才能访问
        },
        component: () => import('../views/admin/pages/orgDetail/supervision'),
    },
    {
        path: 'orgEvaluate',
        meta: {
            title: '星级评定',
            needLogin: true // 是否需要登录才能访问
        },
        component: () => import('../views/admin/pages/orgDetail/evaluateList'),
    },
    {
        path: 'orgEvaluateDetail',
        meta: {
            title: '星级评定',
            needLogin: true // 是否需要登录才能访问
        },
        component: () => import('../views/admin/pages/orgDetail/evaluateDetail'),
    },
    {
        path: 'evaluateList',
        meta: {
            title: '星级评定管理',
            needLogin: true // 是否需要登录才能访问
        },
        component: () => import('../views/admin/pages/evaluate/list'),
    },
    {
        path: 'evaluateTotal',
        meta: {
            title: '星级评定管理',
            needLogin: true // 是否需要登录才能访问
        },
        component: () => import('../views/admin/pages/evaluate/total'),
    },
    {
        path: 'evaluateDetail',
        meta: {
            title: '星级评定管理',
            needLogin: true // 是否需要登录才能访问
        },
        component: () => import('../views/admin/pages/evaluate/detail'),
    },
    {
        path: 'riskWarning',
        meta: {
            title: '机构信息',
            needLogin: true // 是否需要登录才能访问
        },
        component: () => import('../views/admin/pages/orgDetail/riskWarning'),
    },
    {
        path: 'orgApply',
        meta: {
            title: '机构信息审核',
            needLogin: true // 是否需要登录才能访问
        },
        component: () => import('../views/admin/pages/orgApply/list'),
    },
    {
        path: 'riskList',
        meta: {
            title: '预警管理',
            needLogin: true // 是否需要登录才能访问
        },
        component: () => import('../views/admin/pages/risk/list'),
    },
    {
        path: 'policiesAndRegulationList',
        meta: {
            title: '政策法规管理',
            needLogin: true // 是否需要登录才能访问
        },
        component: () => import('../views/admin/pages/info/policiesAndRegulation/list'),
    },
    {
        path: 'policiesAndRegulationAdd',
        meta: {
            title: '政策法规管理',
            needLogin: true // 是否需要登录才能访问
        },
        component: () => import('../views/admin/pages/info/policiesAndRegulation/add'),
    },
    {
        path: 'technologyList',
        meta: {
            title: '科技专栏',
            needLogin: true // 是否需要登录才能访问
        },
        component: () => import('../views/admin/pages/info/technology/list'),
    },
    {
        path: 'technologyAdd',
        meta: {
            title: '科技专栏',
            needLogin: true // 是否需要登录才能访问
        },
        component: () => import('../views/admin/pages/info/technology/add'),
    },
    {
        path: 'noticeList',
        meta: {
            title: '通知公告',
            needLogin: true // 是否需要登录才能访问
        },
        component: () => import('../views/admin/pages/info/notice/list'),
    },
    {
        path: 'noticeAdd',
        meta: {
            title: '通知公告',
            needLogin: true // 是否需要登录才能访问
        },
        component: () => import('../views/admin/pages/info/notice/add'),
    },
    {
        path: 'promotionalList',
        meta: {
            title: '宣传信息管理',
            needLogin: true // 是否需要登录才能访问
        },
        component: () => import('../views/admin/pages/info/promotional/list'),
    },
    {
        path: 'promotionalAdd',
        meta: {
            title: '宣传信息管理',
            needLogin: true // 是否需要登录才能访问
        },
        component: () => import('../views/admin/pages/info/promotional/add'),
    },
    {
        path: 'downloadList',
        meta: {
            title: '下载中心管理',
            needLogin: true // 是否需要登录才能访问
        },
        component: () => import('../views/admin/pages/info/download/list'),
    },
    {
        path: 'downloadClassifyList',
        meta: {
            title: '下载中心管理',
            needLogin: true // 是否需要登录才能访问
        },
        component: () => import('../views/admin/pages/info/download/classify'),
    },
    {
        path: 'downloadAdd',
        meta: {
            title: '下载中心管理',
            needLogin: true // 是否需要登录才能访问
        },
        component: () => import('../views/admin/pages/info/download/add'),
    },
    {
        path: 'certifiedEducationalAndTrainingInstitutionList',
        meta: {
            title: '持证教培机构名单',
            needLogin: true // 是否需要登录才能访问
        },
        component: () => import('../views/admin/pages/info/certifiedEducationalAndTrainingInstitution/list'),
    },
    {
        path: 'supervisedAccountList',
        meta: {
            title: '开通监管账户机构',
            needLogin: true // 是否需要登录才能访问
        },
        component: () => import('../views/admin/pages/info/supervisedAccount/list'),
    },
    {
        path: 'institutionalPublicityList',
        meta: {
            title: '机构公示信息管理',
            needLogin: true // 是否需要登录才能访问
        },
        component: () => import('../views/admin/pages/info/institutionalPublicity/list'),
    },
    {
        path: 'objectionAppealList',
        meta: {
            title: '异议申诉管理',
            needLogin: true // 是否需要登录才能访问
        },
        component: () => import('../views/admin/pages/info/objectionAppeal/list'),
    },
    {
        path: 'questionList',
        meta: {
            title: '问题反馈管理',
            needLogin: true // 是否需要登录才能访问
        },
        component: () => import('../views/admin/pages/info/question/list'),
    },
    {
        path: 'account',
        meta: {
            title: '账号管理',
            needLogin: true // 是否需要登录才能访问
        },
        component: () => import('../views/admin/pages/role/account'),
    },
    {
        path: 'log',
        meta: {
            title: '操作日志',
            needLogin: true // 是否需要登录才能访问
        },
        component: () => import('../views/admin/pages/role/log'),
    },
    {
        path: 'password',
        meta: {
            title: '密码管理',
            needLogin: true // 是否需要登录才能访问
        },
        component: () => import('../views/admin/pages/role/password'),
    },
]


export default adminRouter
